import React from 'react'
import styled from 'styled-components'
import BigNumber from 'bignumber.js'
import { Button, Flex, Heading, IconButton, AddIcon, MinusIcon, useModal, Text } from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'
import DepositModal from './DepositModal'
import WithdrawModal from './WithdrawModal'
import { useStake, useUnstake } from '../hooks/useRanches'

interface ActionsProps {
  ranch: any
  lpLabel: string
}

const IconButtonWrapper = styled.div`
  display: flex;
  svg {
    width: 20px;
  }
`

const BLACK_LIST = {
  "0x84272C0f90f5bb78464a1Ae69B5b18AD8A464485": true
};

const StakedBalanceWrapper = styled.div`
  text-align: left;
`

const USValue = styled(Text)`
  font-size: 12px;
`

const getDisplayBalance = (balance) => {
  const displayBalanceOption = balance > 1 ? {} : {maximumFractionDigits: 8};
  const displayBalance = navigator ? balance.toLocaleString(navigator.language, displayBalanceOption) : balance.toLocaleString();
  return displayBalance;
}

const StakeAction: React.FC<ActionsProps> = ({ ranch, lpLabel }) => {
  const TranslateString = useI18n()
  const { depositFeeRate, isEnded, userInfo, lpBalance, lpToken } = ranch;

  const onStake = useStake(ranch.address)
  const onUnstake = useUnstake(ranch.address)

  const rawStakedBalance = (userInfo && userInfo.stakedLp) ? userInfo.stakedLp.toNumber():0;
  const displayBalance = getDisplayBalance(rawStakedBalance);
  const canStake = !isEnded && !BLACK_LIST[ranch.address];

  const lpStakedValue = lpBalance.div(lpToken.totalSupply).times(lpToken.value || 0);
  const userShare = (userInfo && lpBalance.isGreaterThan(0)) ? userInfo.stakedLp.div(lpBalance).toNumber() : 0;
  const stakedValue = lpStakedValue.times(userShare).toNumber();
  const displayStakedValue = stakedValue.toLocaleString();

  const [onPresentDeposit] = useModal(<DepositModal max={userInfo && userInfo.lpBalance || new BigNumber(0)} onConfirm={onStake} lpLabel={lpLabel} depositFeeBP={depositFeeRate*100} />)
  const [onPresentWithdraw] = useModal(
    <WithdrawModal max={userInfo && userInfo.stakedLp || new BigNumber(0)} onConfirm={onUnstake} lpLabel={lpLabel} />,
  )

  const renderStakingButtons = () => {
    return rawStakedBalance === 0 ? (
      <Button onClick={onPresentDeposit} disabled={!canStake}>{TranslateString(94, 'Stake')}</Button>
    ) : (
      <IconButtonWrapper>
        <IconButton variant="tertiary" onClick={onPresentWithdraw} mr="6px">
          <MinusIcon color="primary" />
        </IconButton>
        <IconButton variant="tertiary" onClick={onPresentDeposit} disabled={!canStake}>
          <AddIcon color="primary" />
        </IconButton>
      </IconButtonWrapper>
    )
  }

  return (
    <Flex justifyContent="space-between" alignItems="center">
      <StakedBalanceWrapper>
        <Heading color={rawStakedBalance === 0 ? 'textDisabled' : 'text'}>{displayBalance}</Heading>
        {stakedValue>0? (<USValue>~${displayStakedValue}</USValue>): ""}
      </StakedBalanceWrapper>
      {renderStakingButtons()}
    </Flex>
  )
}

export default StakeAction
